import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { domainDetailLoad } from "store/models/domain";
import { DetailLoadComponent } from 'components/common';


const HiddenDomainValue = (props) => {
  return (
    <DetailLoadComponent
      apiLoad={domainDetailLoad}
      {...props}
      getDetailUrl={(id, item) => props.model.urls.detail(id)}
      render={({ id, item, linkPath }) => {
        const value = (item && item.hidden_domain) || id;

        return (
          <Fragment>
            {props.asLink && linkPath ?
              <Link to={linkPath} style={{whiteSpace: 'nowrap'}}>{value}</Link> :
              <span>{value}</span>}
          </Fragment>
        );
      }}
    />
  );
};

const mapState = state => ({
  router: state.router,
  authToken: state.auth.token,
  model: state.hiddenDomain,
});

export default connect(mapState)(HiddenDomainValue);
